import product_badge_attributes from '/srv/web/wyvr/html/releases/58819/gen/client/shop/config/product_badge_attributes.js?1733898722612';
import product_configurable_attributes from '/srv/web/wyvr/html/releases/58819/gen/client/shop/config/product_configurable_attributes.js?1733898722612';

export default [
    'sku',
    'name',
    'thumbnail',
    'url_key',
    'price',
    'final_price',
    {
        attribute: 'pim_brand',
        all: true,
    },
    'special_price',
    ...product_configurable_attributes,
    ...product_badge_attributes,
];
